/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsMegaMenu = {
  isSetup: false,
  init: function($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsMegaMenu = $.extend(this, window.PXUTheme.getSectionData($section));

    // Selectors
    const parentLink = this.parent_link;
    const sectionId = this.section_id;
    const $megaMenu = $section.find('.mega-menu__' + sectionId);
    const $parentElement = $('.header__menu [data-navlink-handle="' + parentLink + '"], .sticky-header__menu [data-navlink-handle="' + parentLink + '"]');
    const $parentElementLink = $parentElement.find('.header__link');
    // Remove old mega menus
    $parentElement.find('.mega-menu__section').remove();

    // Mobile Selectors
    const $parentMobileElement = $(`[data-mobile-menu-navlink-handle="${parentLink}"]`);

    /* No submenu is present - add mega menu elements and caret */
    if ($parentMobileElement.find('.has-no-submenu').length) {

      // Assign class to display dropdown arrow
      $parentMobileElement.find('a.mobile-menu__item').addClass('mobile-menu-link');

      // Insert close icon after menu item
      $parentMobileElement.find('a').after('<span class="close-dropdown" aria-expanded="false"></span>');

      // Insert placeholder ul for megamenu
      $parentMobileElement.find('.submenu__label').after('<ul class="mobile-submenu__list mobile-menu__submenu has-mega-menu" data-mobile-submenu-first-level-list></ul>')

      // Find data attribute for toggle and assign it true
      let $mobileMenuToggle = $parentMobileElement.find('[data-mobile-menu-has-toggle]');
      $($mobileMenuToggle).attr('data-mobile-menu-has-toggle', true);


      // Insert mega menu
      let $parentList = $parentMobileElement.find('.has-mega-menu');
      $megaMenu.clone().appendTo($parentList);

    } else {
      /* Submenu is present - add mega menu elements and remove current sub-menu */
      let $parentList = $parentMobileElement.find('[data-mobile-submenu-first-level-list]');

      $parentList
        .empty()
        .addClass('has-mega-menu')
        .removeClass('has-dropdown');

      // Insert mega menu
      $megaMenu.clone().appendTo($parentList);
    }


    // Desktop
    if ($parentElement.hasClass('header__item') || $parentElement.hasClass('vertical-header__first-level')) {
      // Hide default dropdown
      $parentElement.find('.navbar-dropdown').addClass('is-invisible is-hidden');

      // Add arrow to parent link to indicate dropdown
      $parentElementLink.removeClass('is-arrowless');

      $megaMenu.clone().appendTo('.vertical-header__first-level[data-navlink-handle="' + parentLink + '"], .header__item[data-navlink-handle="' + parentLink + '"]');

      // Add/remove classes for proper styling and append mega menu instance
      $parentElement.addClass('has-mega-menu')
    }

    // Determine if header is set to hover to open or click to open
    if ($('.dropdown-click--false').length > 0) {
      $('.navbar-item, .header__brand, .header__search').on('mouseover', function(){

        //Close any mega menus on hover
        $('.mega-menu__section').removeClass('is-active');

        if($(this).hasClass('has-mega-menu')) {

          //Toggle corresponding mega menu
          $(this).find('.mega-menu__section').addClass('is-active');
          $('body').addClass('mega-menu__is-open'); /* Add body style - dagoodma 3/8/2024 */
        }
      })

      /* Added by dagoodma of CampaignTrip - 3/10/24.
       * Prevent closing menu when scrolling off to left or right.
       * Added escape key press to close menu also.
       */
      $('.mega-menu__section, .navbar').on('mouseleave', function(e){
        var $this = $(this);
        var minWidth = 0;
        var maxWidth = $this.width();
        //console.log("Here with mouselave: ", e);
        if (e.pageX >= minWidth && e.pageX <= maxWidth) {
          window.PXUTheme.jsMegaMenu.hideMenu();
        }
      })

      /* Hide mega menu on escape press */
      if (!window.PXUTheme.jsMegaMenu.isSetup) {
        $(function() {
          $(document).on('keyup', function(e) {
            if (window.PXUTheme.jsMegaMenu.isMenuDisplayed()) {
              e = e || window.event;
              var isEscape = false;
              if ("key" in e) {
                isEscape = (e.key === "Escape" || e.key === "Esc");
              } else {
                isEscape = (e.keyCode === 27);
              }
              if (isEscape) {
                window.PXUTheme.jsMegaMenu.hideMenu();
              }
            }
          });
        });
      }



    } else {
      $('.navbar-item, .header__brand, .header__search').on('click touchstart', function(){

        //Close any mega menus on click
        $('.mega-menu__section').removeClass('is-active');

        if($(this).hasClass('has-mega-menu')) {

          //Toggle corresponding mega menu
          $(this).find('.mega-menu__section').addClass('is-active');
          $('body').addClass('mega-menu__is-open');
        }
      })
    }

    /* Added by dagoodma of CampaignTrip - 3/10/24.
     * Clicking anywhere off the menu will close it.
     */
    if (!window.PXUTheme.jsMegaMenu.isSetup) {
      $(document).on('click touchstart', function(e){
        if (window.PXUTheme.jsMegaMenu.isMenuDisplayed()) {
          var $target = $(e.target);
          if (!($target.parents('.mega-menu__section').length ||
            $target.parents('#header').length)) {
            window.PXUTheme.jsMegaMenu.hideMenu();
          }
        }
      });
    }

    /* Added by dagoodma of CampaignTrip - 3/2/24.
     * Disable navigate on link click for mobile mega menu.
     */
    //$('.mobile-menu__item.mobile-menu-link').on('click touchstart', function(e){
    var $label = $parentMobileElement.find('.submenu__label');
    if ($label.length) {
      $label.on('click ', function(e){
        var $this = $parentMobileElement;

        if ($this.find('.has-no-submenu').length) {
          // Prevent link load on click
          e.preventDefault();

          // Is it not already displayed?
          if (!window.PXUTheme.jsMegaMenu.isMenuDisplayed(sectionId)) {
            window.PXUTheme.jsMegaMenu.displayMenu(sectionId);
            var $mm = $this.find('.has-mega-menu');
            if ($mm.length) {
              $('.mobile-menu__submenu.has-mega-menu').removeClass('is-displayed');
              $mm.addClass('is-displayed');
            }
          } else {
            var $mm = $this.find('.has-mega-menu');
            if ($mm.length) {
              $mm.removeClass('is-displayed');
            }
            window.PXUTheme.jsMegaMenu.hideMenu(sectionId);
          }
        }

      });
    } // if ($label.length)
    window.PXUTheme.jsMegaMenu.isSetup = true;
  },
  showThemeEditorState: function(id, $section) {
    $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--force-show');
    $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').addClass('is-active');
  },
  hideThemeEditorState: function(id, $section) {
    $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--force-show');
    $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').removeClass('is-active');
  },
  displayMenu: function(id) {
    $('.mega-menu').removeClass('mega-menu--show');
    $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--show');

    // hide tidio chat - dagoodma 3/8/2024
    $chat = $('#tidio-chat-iframe');
    if ($chat.length > 0) {
      console.log('Hiding tidio...');
      $chat.css('display', 'none');
    }

  },
  /* Mobile mega menu needs an id, and desktop does not. */
  hideMenu: function(id) {
    if (arguments.length > 0 ) {
      $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--show');

      // show tidio chat - dagoodma 3/8/2024
      $chat = $('#tidio-chat-iframe');
      if ($chat.length > 0) {
        console.log('Showing tidio...');
        $chat.css('display', 'block');
      }
    } else {
      $('.mega-menu__section').removeClass('is-active');
      $('body').removeClass('mega-menu__is-open'); /* Add body style - dagoodma 3/8/2024 */
    }
  },
  /* Mobile mega menu needs an id, and desktop does not. */
  isMenuDisplayed: function(id) {
    if (arguments.length > 0 ) {
      var $mm = $('.mega-menu__' + id + ' .mega-menu');
      if ($mm.length) return $mm.hasClass('mega-menu--show');
      return false;
    } else {
      return $('body').hasClass('mega-menu__is-open');
    }
  },
  unload: function($section) {
    let parentLink = $section.find('.mega-menu').data('parent-link');
    let navLink = $('[data-navlink-handle="' + parentLink + '"]')
    navLink.off();
    navLink.find('.mega-menu__section').remove();
    $('.mega-menu__section, .navbar, .navbar-item, .header__brand, .header__search').off();
  }
}

/******/ })()
;
